import { NgxSliderModule } from '@angular-slider/ngx-slider'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { FormatPipeModule, ParseIsoPipeModule } from 'ngx-date-fns'
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input'
import { NgxPaginationModule } from 'ngx-pagination'
import { SharedFlokModule } from '../../module/shared-flok/shared-flok.module'
import { SharedMemberModule } from '../../module/shared-member/shared-member.module'
import { SearchChooseFiltersComponent } from './search-criteria/search-choose-filters/search-choose-filters'
import { SearchCriteriaComponent } from './search-criteria/search-criteria'
import { SearchCriteriaAvailabilityTypeComponent } from './search-criteria/search-criteria-availability-type/search-criteria-availability-type'
import { SearchCriteriaGuestsComponent } from './search-criteria/search-criteria-guests/search-criteria-guests'
import { MenuPanelComponent } from './search-criteria/search-criteria-where-to-menu/menu-panel/menu-panel'
import { SearchAiComponent } from './search-criteria/search-ai/search-ai'
import { SearchCriteriaWhereToMenuComponent } from './search-criteria/search-criteria-where-to-menu/search-criteria-where-to-menu'
import { SearchFiltersComponent } from './search-criteria/search-filters/search-filters'
import { SearchFiltersModalComponent } from './search-criteria/search-filters-modal/search-filters-modal'
import { SearchFiltersExtendedComponent } from './search-criteria/search-filters-extended/search-filters-extended'
import { SearchTextComponent } from './search-criteria/search-text/search-text'
import { MapMarkerComponent } from './search-criteria/search-map/map-marker/map-marker'
import { SearchMapComponent} from './search-criteria/search-map/search-map'
import { SearchListingComponent } from './search-listing/search-listing'
import { SearchListingsComponent } from './search-listings'
import { SearchListingsRoutingModule } from './search-listings-routing.module'

@NgModule({
    declarations: [
        SearchAiComponent,
        SearchChooseFiltersComponent,
        SearchFiltersModalComponent,
        SearchFiltersComponent,
        SearchFiltersExtendedComponent,
        SearchCriteriaAvailabilityTypeComponent,
        SearchCriteriaGuestsComponent,
        SearchCriteriaComponent,
        SearchListingComponent,
        SearchListingsComponent,
        SearchCriteriaWhereToMenuComponent,
        SearchTextComponent,
        SearchMapComponent,
        MapMarkerComponent,
        MenuPanelComponent
    ],
    exports: [
        SearchCriteriaComponent,
        SearchCriteriaGuestsComponent,
        SearchListingsComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatCardModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatMenuModule,
        NgxPaginationModule,
        ReactiveFormsModule,
        SearchListingsRoutingModule,
        SharedFlokModule,
        SharedMemberModule,
        FormatPipeModule,
        ParseIsoPipeModule,
        NgxSliderModule,
        MatCheckboxModule,
        NgxIntlTelInputModule,
        MatProgressBarModule,
    ]
})
export class SearchListingsModule {}
